import React from "react";

const BasketProducts = ({
  products,
  onRemoveClick,
  removingProductIds
}) => (
  <table className="table table-bordered">
    <tbody>
      {products.map((product, product_index) => (
        <tr key={`product_${product_index}`}>
          <td>
            <div className="basket__product-wrapper">
              <img
                src={product.thumbnailPhotoUrl}
                className="basket__product-photo"
              />
              {product.descriptions.map(
                (description, description_index) =>
                  description_index == 0 ? (
                    <h3
                      key={`description_${product_index}_${description_index}`}
                      className="basket__product-description--main"
                    >
                      {description}
                    </h3>
                  ) : (
                    <span
                      key={`description_${product_index}_${description_index}`}
                    >
                      {description}
                    </span>
                  )
              )}
              <a
                className="btn btn-default basket__remove-product"
                onClick={() => onRemoveClick(product.id)}
              >
                {removingProductIds.indexOf(product.id) >= 0 ? (
                  <i className="fa fa-spinner fa-spin" />
                ) : (
                  <i className="fa fa-trash-o" />
                )}
              </a>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default BasketProducts;